import { isLocalHostname } from '@shared/helpers/environment.helpers';

export type Auth0CacheLocation = 'memory' | 'localstorage';

/**
 * Where Auth0 stores tokens. Localhost uses localStorage so HMR remounts and
 * ErrorBoundary reloads keep the session. Hosted apps stay on memory cache.
 */
export const getAuth0CacheLocation = (hostname: string): Auth0CacheLocation =>
  isLocalHostname(hostname) ? 'localstorage' : 'memory';

/**
 * Allow iframe silent-auth when a refresh token is missing (common on localhost
 * after a full reload). Hosted apps keep the SDK default.
 */
export const shouldUseAuth0RefreshTokenFallback = (hostname: string): boolean =>
  isLocalHostname(hostname);
